import React, { Component } from 'react'
import { Helmet } from "react-helmet";
import { connect } from 'react-redux'
import { Home, Detail, Results } from './routes'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { fetchKnowledgeBases } from './actions/knowledgeBaseActions'

class App extends Component {
	constructor(props) {
		super(props)
		if (window) {
			window.T1 = window.T1 || {}
			window.T1.websiteSettings = {
				displayPrivacyToolbar: false,
			}
		}

		props.fetchKnowledgeBases(props.brand)
	}

	render() {
		const { brand } = this.props

		return (
			<Router>
				<Helmet>
					<link rel="icon" type="image/x-icon" href={`/favicon-${brand}.ico`} />
				</Helmet>
				<div className="customer-service">
					<Switch>
						<Route exact path="/" render={props => <Home brand={brand} {...props} />} />
						<Route
							exact
							path="/results/:query?"
							render={props => <Results brand={brand} {...props} />}
						/>
						<Route exact path="/:nodeId" render={props => <Detail brand={brand} {...props} />} />
					</Switch>
				</div>
			</Router>
		)
	}
}

const mapStateToProps = state => ({
	...state,
})
const mapDispatchToProps = dispatch => ({
	fetchKnowledgeBases: brand => dispatch(fetchKnowledgeBases(brand)),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
